import config from "@Config/index";

/**
 * Resolves an Essential Kit asset path against the configured asset base.
 *
 * Every asset/font reference in the feature must flow through this helper so the
 * base is swappable without touching components:
 *   - POC:        UNIKIT_ASSET_URL = "/static/essential-kit/" (served from public/)
 *   - Final step: UNIKIT_ASSET_URL = the gumlet CDN base (config-only change)
 *
 * Only known local roots (`/assets/`, `/fonts/`) are rewritten. Absolute URLs and
 * any other path are returned unchanged. Replaces the source's Vite-only
 * `import.meta.env.BASE_URL` implementation.
 */
export const assetUrl = (path: string): string => {
  if (!path) return path;
  if (/^https?:\/\//.test(path)) return path;
  if (!path.startsWith("/assets/") && !path.startsWith("/fonts/")) return path;

  const rawBase = config.UNIKIT_ASSET_URL || "/";
  const base = rawBase.endsWith("/") ? rawBase : `${rawBase}/`;
  return `${base}${path.slice(1)}`;
};

export default assetUrl;
